import {
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
} from "react-router-dom";
import "./reset.css";
import "./App.css";
import {
    Home,
    Blog,
    NotFound,
    Projects,
    Projectdetail,
    Blogdetail,
    Opleiding,
    Services,
    Programma,
    Team,
    Search,
} from "./pages/index";
import Root from "./layouts/Root";
import { ROUTES } from "./routes/routes";
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<Root />} errorElement={<NotFound />}>
            <Route path={ROUTES.home.path} element={<Home />} />
            <Route path={ROUTES.blog.path} element={<Blog />} />
            <Route path={ROUTES.project.path} element={<Projects />} />
            <Route path={ROUTES.blogdetail.path} element={<Blogdetail />} />
            <Route path={ROUTES.opleiding.path} element={<Opleiding />} />
            <Route path={ROUTES.services.path} element={<Services />} />
            <Route path={ROUTES.programma.path} element={<Programma />} />
            <Route path={ROUTES.search.path} element={<Search />} />
            <Route path={ROUTES.team.path} element={<Team />} />
            <Route
                path={ROUTES.projectdetail.path}
                element={<Projectdetail />}
            />
        </Route>
    )
);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
